import type { ElementType, HTMLAttributes } from "react";
import "./layout.css";

/**
 * The --space-* scale, as a closed union. A gap prop typed this way makes it
 * structurally impossible to pass a raw pixel value or arbitrary string —
 * see apps/web/THEMING.md.
 */
export type SpaceScale = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Gap between children, from the --space-* scale. Default 4 (var(--space-4)). */
  gap?: SpaceScale;
  /** cross-axis alignment (align-items). */
  align?: "start" | "center" | "end" | "stretch";
  as?: ElementType;
}

/** Vertical flex layout. Use instead of inline style={{ display: "flex", flexDirection: "column", gap }}. */
export function Stack({ gap = 4, align, as: Component = "div", className, ...rest }: StackProps) {
  const classes = ["ui-stack", `ui-gap-${gap}`, className].filter(Boolean).join(" ");
  return <Component className={classes} style={align ? { alignItems: align } : undefined} {...rest} />;
}
